// version.js
export const app_ver = '1.0.9'; // Named export
//export const date = '05-04-2025'; version 1
//export const date = '17-04-2025';  version 3
//export const date = '19-04-2025';  version 4

export const date = '21-04-2025'; 
// version 4

// If you want a default export as well
const defaultExport = { app_ver, date };
export default defaultExport;
